<template>
  <div class="kpi-home-container" v-if="canViewFront || canViewBack || canViewNames">
    <div class="tabs">
      <van-tabs v-model="activeName" @change="onChangeTab">
        <van-tab title="前端指标" name="front" v-if="canViewFront"></van-tab>
        <van-tab title="后端指标" name="back" v-if="canViewBack"></van-tab>
        <van-tab title="名单供应商" name="call-line" v-if="canViewNames"></van-tab>
      </van-tabs>
    </div>
    <div class="content">
      <div class="content-wrap">
        <div class="box-wrap">
          <div class="quick-choose">
            <div class="quickTimeWrap">
              <div class="timeItem active" @click="onShowDateSelector">选择日期</div>
            </div>
            <div class="service-btn">
              <van-checkbox :value="true" checked-color="#ee0a24" icon-size="12">汇总</van-checkbox>
            </div>
          </div>
          <div class="box">
            <div class="box-dashboard">
              <div class="today">
                <p class="today-cal">{{ dateInfoText[0] }}</p>
                <p class="today-cal">{{ dateInfoText[1] }}</p>
                <p class="today-text">{{ dateDays }} 天 回 款</p>
              </div>
              <div class="national-box">
                <div class="boxOffice-num"><span class="num">{{ total }}</span>元</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-table">
          <h1 class="table-title">数据详情</h1>
          <TableFront v-if="activeName === 'front'" :scroll-width="2000" :table-data="tableData" key-name="rowKey"
            @on-expand="onExpandFront" />
          <TableBack v-if="activeName === 'back'" :scroll-width="1800" :table-data="tableData" key-name="rowKey"
            @on-expand="onExpandBack" />
          <TableCallLine v-if="activeName === 'call-line'" :scroll-width="900" :table-data="tableData" key-name="rowKey"
            @on-expand="onExpandNames" />
        </div>
      </div>
    </div>
    <van-calendar v-model="showDateSelector" type="range" allow-same-day @confirm="onConfirmDate"
      :default-date="dateInfo" :min-date="new Date(2010, 0, 1)" />
  </div>
</template>

<script>
import DayJs from 'dayjs'
import { mapGetters } from 'vuex'
import TableFront from './table-front'
import TableBack from './table-back'
import TableCallLine from './table-call-line'
import { formatMoney, hasOneOf } from '@/util'
import { fetchRoleCodeList } from '@/services/UserService'
import {
  getTotalCommissionAmount,
  getKpiFrontStatistic,
  getKpiBackStatistic,
  getKpiCallLinStatistic,
  getKpiStatisticNS
} from '@/services/KpiService'

export default {
  components: {
    TableFront,
    TableBack,
    TableCallLine
  },
  data() {
    return {
      openId: localStorage.getItem('openId'),
      roleCodeList: [],
      activeName: '',
      dateInfo: [new Date(), new Date()],
      dateInfoText: [
        DayJs().format('YYYY-MM-DD'),
        DayJs().format('YYYY-MM-DD')
      ],
      dateDays: 1,
      showDateSelector: false,
      tableData: [],
      total: '0'
    }
  },
  computed: {
    ...mapGetters([
      'achievementRate'
    ]),
    canViewFront() {
      return this.roleCodeList && this.roleCodeList.length &&
        hasOneOf(this.roleCodeList, ['T', 'M', 'VL', 'L1'])
    },
    canViewBack() {
      return this.roleCodeList && this.roleCodeList.length &&
        hasOneOf(this.roleCodeList, ['T', 'M', 'VL', 'V', 'L1'])
    },
    canViewCallLine() {
      return this.roleCodeList && this.roleCodeList.length &&
        hasOneOf(this.roleCodeList, ['T', 'M'])
    },
    canViewNames() {
      return this.roleCodeList && this.roleCodeList.length &&
        hasOneOf(this.roleCodeList, ['T', 'M'])
    }
  },
  async mounted() {
    await this.onInitRoleCodeList()
    this.activeName = this.onComputeActiveName()
    this.$toast.loading({
      duration: 0,
      message: '数据加载中...',
      forbidClick: true
    })
    await this.onInitData(this.activeName)
    await this.onGetTotalCommission()
    this.$toast.clear()
  },
  methods: {
    async onInitRoleCodeList() {
      const response = await fetchRoleCodeList({ openId: this.openId })
      const roleCodeList = response.data || []
      this.roleCodeList = roleCodeList
    },
    async onInitData(name) {
      if (name) {
        switch (name) {
          case 'front':
            await this.onInitFrontData()
            break
          case 'back':
            await this.onInitBackData()
            break
          case 'call-line':
            await this.onInitNamesData()
            break
        }
      }
    },
    async onGetTotalCommission() {
      const response = await getTotalCommissionAmount({
        openId: this.openId,
        startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59'
      })
      const total = (response.data.commissionAmountTotal * this.achievementRate).toFixed(0)
      this.total = formatMoney(total)
    },
    async onInitFrontData() {
      const response = await getKpiFrontStatistic({
        openId: this.openId,
        startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59'
      })
      this.tableData = response.data.kpiList
    },
    async onExpandFront(row, rowIndex) {
      if (!row.isExpand) {
        this.$set(row, 'isExpand', true)
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await getKpiFrontStatistic({
          openId: this.openId,
          startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59',
          userId: row.l1UserId
        })
        this.$toast.clear()
        const kpiList = (response.data.kpiList || []).map(item => ({
          ...item,
          isLeaf: true
        }))
        this.tableData.splice(rowIndex + 1, 0, ...kpiList)
      } else {
        for (let index = rowIndex + 1; index < this.tableData.length; index++) {
          if (this.tableData[index].isLeaf) {
            this.tableData[index] = undefined
          } else {
            break
          }
        }
        this.$set(row, 'isExpand', false)
        this.tableData = this.tableData.filter(item => !!item)
      }
    },
    async onInitBackData() {
      const response = await getKpiBackStatistic({
        openId: this.openId,
        startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59'
      })
      const kpiList = (response.data.kpiList || []).map(item => {
        if (item.vlUserId) {
          return {
            ...item,
            canExpand: true
          }
        }
        return {
          ...item,
          canExpand: false
        }
      })
      this.tableData = kpiList
    },
    async onExpandBack(row, rowIndex) {
      if (!row.isExpand) {
        this.$set(row, 'isExpand', true)
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await getKpiBackStatistic({
          openId: this.openId,
          startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59',
          userId: row.vlUserId
        })
        this.$toast.clear()
        const kpiList = (response.data.kpiList || []).map(item => ({
          ...item,
          isLeaf: true
        }))
        this.tableData.splice(rowIndex + 1, 0, ...kpiList)
      } else {
        for (let index = rowIndex + 1; index < this.tableData.length; index++) {
          if (this.tableData[index].isLeaf) {
            this.tableData[index] = undefined
          } else {
            break
          }
        }
        this.$set(row, 'isExpand', false)
        this.tableData = this.tableData.filter(item => !!item)
      }
    },
    async onInitNamesData() {
      const response = await getKpiStatisticNS({
        openId: this.openId,
        startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59'
      })
      const kpiList = (response.data.kpiList || []).map(item => {
        if (item.l1UserId !== '0') {
          return {
            ...item,
            canExpand: true
          }
        }
        return {
          ...item,
          canExpand: false
        }
      })
      this.tableData = kpiList
    },
    async onExpandNames(row, rowIndex) {
      if (!row.isExpand) {
        this.$set(row, 'isExpand', true)
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await getKpiStatisticNS({
          openId: this.openId,
          startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59',
          namesSupplier: row.namesSupplier
        })
        this.$toast.clear()
        const kpiList = (response.data.kpiList || []).map(item => ({
          ...item,
          namesSupplier: item.importBundle,
          isLeaf: true
        }))
        this.tableData.splice(rowIndex + 1, 0, ...kpiList)
      } else {
        for (let index = rowIndex + 1; index < this.tableData.length; index++) {
          if (this.tableData[index].isLeaf) {
            this.tableData[index] = undefined
          } else {
            break
          }
        }
        this.$set(row, 'isExpand', false)
        this.tableData = this.tableData.filter(item => !!item)
      }
    },
    async onInitCallLineData() {
      const response = await getKpiCallLinStatistic({
        openId: this.openId,
        startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59'
      })
      this.loading = false
      this.tableData = (response.data || []).map(item => {
        if (item.callLine === '汇总' || !item.callLine) {
          return {
            ...item,
            canExpand: false
          }
        }
        return {
          ...item,
          canExpand: true
        }
      })
    },
    async onExpandCallLine(row, rowIndex) {
      if (!row.isExpand) {
        this.$set(row, 'isExpand', true)
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await getKpiCallLinStatistic({
          openId: this.openId,
          startDate: DayJs(this.dateInfo[0]).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: DayJs(this.dateInfo[1]).format('YYYY-MM-DD') + ' 23:59:59',
          callLine: row.callLine
        })
        this.$toast.clear()
        const kpiList = (response.data || []).map(item => ({
          ...item,
          isLeaf: true
        }))
        this.tableData.splice(rowIndex + 1, 0, ...kpiList)
      } else {
        for (let index = rowIndex + 1; index < this.tableData.length; index++) {
          if (this.tableData[index].isLeaf) {
            this.tableData[index] = undefined
          } else {
            break
          }
        }
        this.$set(row, 'isExpand', false)
        this.tableData = this.tableData.filter(item => !!item)
      }
    },
    onShowDateSelector() {
      this.showDateSelector = true
    },
    async onConfirmDate(date) {
      this.showDateSelector = false
      this.dateInfo = date
      this.dateInfoText = [
        DayJs(date[0]).format('YYYY-MM-DD'),
        DayJs(date[1]).format('YYYY-MM-DD')
      ]
      this.dateDays = DayJs(date[1]).diff(DayJs(date[0]), 'days') + 1
      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      await this.onGetTotalCommission()
      await this.onInitData(this.activeName)
      this.$toast.clear()
    },
    async onChangeTab(name) {
      this.activeName = name
      this.tableData = []
      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      await this.onGetTotalCommission()
      await this.onInitData(this.activeName)
      this.$toast.clear()
    },
    onComputeActiveName() {
      if (hasOneOf(this.roleCodeList, ['T', 'M', 'L1'])) {
        return 'front'
      } else if (hasOneOf(this.roleCodeList, ['T', 'M', 'VL', 'V'])) {
        return 'back'
      } else if (hasOneOf(this.roleCodeList, ['T', 'M'])) {
        return 'call-line'
      }

      return ''
    }
  },
  watch: {
    async roleCodeList() {
      this.activeName = this.onComputeActiveName()

      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      await this.onGetTotalCommission()
      await this.onInitData(this.activeName)
      this.$toast.clear()
    }
  }
}
</script>

<style lang="less">
.kpi-home-container {
  height: calc(100vh - 50px);
  background-color: #f2f2f2;
  overflow: auto;

  .tabs {
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 99;
  }

  .content {
    padding: 44px 0 0 0;

    .content-wrap {
      padding-top: 10px;

      .box-wrap {
        background-color: #fff;
        padding: 15px;
        text-align: center;

        .quick-choose {
          display: flex;
          justify-content: space-between;

          .quickTimeWrap {
            font-size: 14px;
            color: #333;
            font-weight: bold;
            line-height: 20px;
            display: flex;
            background: #fff;

            .timeItem {
              padding: 6px 10px;
              background: #f2f2f2;
              border-radius: 4px;
              margin-right: 10px
            }

            .moreDay {
              font-weight: normal;
              color: #666;
              font-size: 12px;
              margin-right: 0
            }

            .active {
              background: #f1303d;
              color: #fff
            }
          }

          .service-btn {
            float: right;
            color: #666;
            border: .02rem solid #f2f2f2;
            border-radius: 4px;
            background: #fff;
            padding: 0 6px 0 6px;
            font-size: 12px;
            display: flex;
            align-items: center;
          }
        }

        .box {
          margin-top: 17px;

          .box-dashboard {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #f1303d;
            font-size: 12px;
            line-height: 17px;

            .today {
              margin-right: 3px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              .today-cal {
                letter-spacing: 1px
              }

              .today-text {
                word-spacing: 4px;
              }
            }

            .national-box {
              .boxOffice-num {
                .num {
                  font-size: 46px;
                  line-height: 64px;
                  font-family: "MaoYanHeiTi-H"
                }
              }
            }
          }

          .nowTime {
            font-size: 11px;
            line-height: 16px;
            color: #999;
          }
        }
      }

      .box-table {
        margin-top: 8px;
        background-color: #fff;

        .table-title {
          font-size: 18px;
          line-height: 25px;
          padding: 10px 15px;
          font-family: 'PingFangSC-Medium';
          margin: 0;
        }

        .ve-table-header-tr,
        .ve-table-body-tr,
        .ve-table-expand-tr {
          height: 30px !important;
        }

        .ve-table-header-th,
        .ve-table-body-td,
        .ve-table-expand-td-content {
          font-size: 12px !important;
          padding: 6px !important;
        }

        .iconfont-vet {
          font-size: 12px !important;
        }

        .ve-table-row-expand-icon {
          width: 15px !important;
          height: 15px !important;
        }
      }
    }
  }
}

.no-auth-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
